import React, { useCallback, useContext, useEffect } from 'react';
import classnames from 'classnames';
import { DropdownStateContext } from '../../Dropdown/DropdownStateManager/DropdownStateContext';
import StandardMenu from '../../Dropdown/MenuPreset/StandardMenu';
import { gallectionTypeToResourceType } from '../../types/gallection';
import FolderInfo from './FolderInfo';
import FolderThumb from './FolderThumb';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import folderDropdownDesktopStyles from './FolderDropdownDesktop.scss';
const hasSubFolders = (folder)=>folder.hasSubfolders || folder.subfolders && folder.subfolders.length > 0;
const FolderDropdownDesktopMenu = ({ id , isOpen: forceOpen , className , folders , filterEmpty , currentFolder , hasMore , setSelectedFolderId , fetchMore  })=>{
    const { isOpen , closeDropdown  } = useContext(DropdownStateContext);
    const selectFolder = useCallback((folderId)=>{
        setSelectedFolderId(folderId);
        closeDropdown();
    }, [
        setSelectedFolderId,
        closeDropdown
    ]);
    useEffect(()=>{
        if ((isOpen || forceOpen) && hasMore && fetchMore) {
            fetchMore();
        }
    }, [
        isOpen,
        forceOpen,
        hasMore,
        fetchMore
    ]);
    if (!(isOpen || forceOpen)) {
        return null;
    }
    var _folder_subfolders;
    const menuItems = folders.flatMap((folder)=>[
            folder,
            ...(_folder_subfolders = folder.subfolders) !== null && _folder_subfolders !== void 0 ? _folder_subfolders : []
        ]).filter((folder)=>!filterEmpty || folder.size > 0 || hasSubFolders(folder)).map((folder, index)=>({
            label: folder.name,
            value: folder.folderId,
            biData: BiData({
                evid: 100,
                rank: index,
                creatorid: folder.owner.useridUuid,
                typeid: gallectionTypeToResourceType(folder.type),
                itemid: folder.folderId,
                sectionid: BiContextProvidedValue,
                sectionname: BiContextProvidedValue,
                section_typeid: BiContextProvidedValue,
                sectiontype: BiContextProvidedValue,
                widgetname: BiContextProvidedValue
            }),
            complexLabel: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FolderInfo, {
                folder: folder
            }), /*#__PURE__*/ React.createElement(FolderThumb, {
                folder: folder,
                hasSubfolders: hasSubFolders(folder)
            })),
            className: classnames(folderDropdownDesktopStyles['menu-item'], currentFolder && currentFolder.folderId === folder.folderId && folderDropdownDesktopStyles['selected'])
        }));
    return /*#__PURE__*/ React.createElement(StandardMenu, {
        id: id,
        className: classnames(className, folderDropdownDesktopStyles['menu']),
        items: menuItems,
        onSelect: selectFolder,
        scrollable: true
    });
};
FolderDropdownDesktopMenu.displayName = 'FolderDropdownDesktopMenu';
export default FolderDropdownDesktopMenu;
